export const CONTACT = {
  phone: "(614) 894-3056",
  phoneHref: "tel:+16148943056",
  facebook: "https://www.facebook.com/share/195m8SDeAX/?mibextid=wwXIfr",
  instagram: "https://www.instagram.com/kingdomadvancementsmm?igsh=cGI5dmc4eHBvcnY4&utm_source=qr",
};

export const CHAPTERS = [
  {
    id: "civic",
    num: "01",
    eyebrow: "Serving",
    title: "Civic Leaders & Public Officials",
    image:
      "https://images.unsplash.com/photo-1764874299006-bf4266427ec9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxwdWJsaWMlMjBzcGVha2VyJTIwcG9kaXVtfGVufDB8fHx8MTc4NjY3Mjk5OHww&ixlib=rb-4.1.0&q=85",
    examples: [
      "Mayors", "Governors", "City Hall Leaders", "State Representatives",
      "State Senators", "Members of Congress", "Attorneys General",
      "County Commissioners", "School Board Members",
    ],
    body:
      "Public servants carry full schedules — meetings, community events, and the complex, behind-the-scenes work of governing. That work rarely gets captured or explained, leaving a gap between the impact a leader makes and how their community perceives it.",
    matters:
      "Social media is often the public's first impression of your leadership. Clear, consistent, human storytelling builds trust, controls your narrative, keeps constituents informed, and turns quiet service into visible community connection — especially with the people inside your district.",
  },
  {
    id: "weddings",
    num: "02",
    eyebrow: "Serving",
    title: "Weddings & Signature Events",
    image:
      "https://images.pexels.com/photos/29040997/pexels-photo-29040997.jpeg",
    examples: [
      "Weddings", "Engagements", "Galas", "Milestone Celebrations",
      "Corporate Events", "Anniversaries", "Fundraisers", "Receptions",
    ],
    body:
      "So many meaningful moments happen behind the scenes of a celebration — and they deserve to live far beyond the event itself. Couples shouldn't have to spend beyond their means to keep the candid magic of their day.",
    matters:
      "Story-driven, budget-friendly content preserves the emotion, expands the experience, and keeps the celebration shareable. Relive and share those memories exactly as they happen — a keepsake that lasts long after the last dance.",
  },
  {
    id: "restaurants",
    num: "03",
    eyebrow: "Serving",
    title: "Restaurants & Hospitality",
    image:
      "https://images.unsplash.com/photo-1750943079462-87bad58cf43e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxmaW5lJTIwZGluaW5nJTIwcmVzdGF1cmFudCUyMGNoZWZ8ZW58MHx8fHwxNzg2NjcyOTk4fDA&ixlib=rb-4.1.0&q=85",
    examples: [
      "Restaurants", "Chefs", "Cafés", "Hotels", "Caterers",
      "Event Venues", "Bars & Lounges", "Bakeries",
    ],
    body:
      "Ohio is home to incredible small restaurants and hospitality spots that deserve far greater visibility. Guests decide where to eat, stay, and celebrate long before they ever walk through the door.",
    matters:
      "Strong visual content turns your atmosphere, service, and signature offerings into visits and reservations. Consistent storytelling showcases your personality, builds recognition, and keeps your tables full.",
  },
  {
    id: "creators",
    num: "04",
    eyebrow: "Serving",
    title: "Content Creators & Local Businesses",
    image:
      "https://images.unsplash.com/photo-1581547848545-a75a2634ba23?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxwb2RjYXN0JTIwcmVjb3JkaW5nJTIwc3R1ZGlvfGVufDB8fHx8MTc4NjY3Mjk5OHww&ixlib=rb-4.1.0&q=85",
    examples: [
      "Creators", "Entrepreneurs", "Retailers", "Service Providers",
      "Community Brands", "Boutiques", "Wellness Studios",
    ],
    body:
      "Businesses shouldn't have to rely only on someone else's platform to be seen. Consistent content on your own pages compounds — building recognition, showcasing personality, and reaching the right audience over time.",
    matters:
      "Consistency makes your brand recognizable while strategy helps it grow. Purposeful content builds credibility, reaches the right people, and turns passive attention into loyal, paying customers.",
  },
];

export const CATEGORY_OPTIONS = [
  "Civic Leaders & Public Officials",
  "Weddings & Signature Events",
  "Restaurants & Hospitality",
  "Content Creators & Local Businesses",
];
